import React, {
  useState,
  useEffect,
  useRef
} from 'react';
import Cookies from 'js-cookie';
import {  useDispatch } from 'react-redux';
import './CancelSuccess.css';

import { Footer } from "../../components/footer/footer";
import Googleadshorizontal from "../../components/google-AdSense/Googleadshorizontal";
import Navbarr from "../../components/header/Navbarr";
import ScrollButton from "../../components/scrollbutton/ScrollButton";
import Subheader from "../../components/subheader/Subheader";

import { ReactComponent as ICONSad } from "../../assets/sad.svg";
import { useSubscription } from '../../shared/hooks/useSubscription';

function CancelSuccess() {
  const firebaseUseruid = Cookies.get('firebaseuid');
  const { subscriptionInfo, loading, error } = useSubscription(firebaseUseruid);

  const dispatch = useDispatch();

  useEffect(() => {
    const canvas = document.getElementById('custom_canvas')

    if (typeof JSConfetti !== "undefined" && canvas) {
      // eslint-disable-next-line no-undef
      const jsConfetti = new JSConfetti({ canvas });

      for (let i = 0; i < 2; i++) {
        setTimeout(() => {
          jsConfetti.addConfetti({
            emojis: ["😭", "😢", "🥺"],
            emojiSize: 50,
            confettiNumber: 150
          });
        }, i * 1000);
      }

    } else {
      console.warn("JSConfetti no está disponible todavía");
    }
  }, []);

  return (<div>
    <Navbarr/>

    <div className="after-nav-dsubheader containers con_div">
      <Googleadshorizontal props="mt-2 mb-2 text-center"/>
      <Subheader />
      
      <div className='h-100 min-vh-100'>
        <h1 className='mt-5 text-white fw-bold text-center'>
          Cancel Subscription Success
        </h1>
        <p className='text-white text-center'>Your subscription has been successfully canceled.</p>

        <canvas id="custom_canvas"></canvas>

        <div className="d-flex gap-5 justify-content-center flex-wrap postion-relative">
          <ICONSad className='w-icon'/>
        </div>
      </div>
    </div>
    <Footer />
    <ScrollButton />
  </div>);
}

export default CancelSuccess;